'use client'

interface StepCardProps {
  stepNumber: number
  title: string
  backgroundColor?: string
  showStepLabel?: boolean
  children?: React.ReactNode
  className?: string
}

export const StepCard = ({
  stepNumber,
  title,
  backgroundColor = '#009CD2',
  showStepLabel = false,
  children,
  className = '',
}: StepCardProps) => {
  return (
    <div
      className={`rounded-2xl border border-solid relative overflow-hidden ${className}`}
      style={{
        backgroundColor,
        borderColor: '#009CD2',
        padding: '24px',
      }}
    >
      {/* 背景の大きなSTEP番号（透かし） */}
      {showStepLabel && (
        <div
          className="absolute pointer-events-none left-[60px] top-[40px] steps:left-[98px] steps:top-[76px]"
          style={{
            transform: 'translate(-60%, -65%)',
          }}
        >
          <img
            src={`/images/three-steps/STEP${stepNumber}.png`}
            alt=""
            aria-hidden="true"
            className="w-[100px] steps:w-[180px] h-auto"
          />
        </div>
      )}

      {/* タイトル */}
      <div className="relative z-10 flex flex-col items-center mb-4" style={{ gap: '8px' }}>
        <div
          className="text-base steps:text-[32px] text-center"
          style={{
            fontWeight: 700,
            letterSpacing: '0.64px',
            lineHeight: '1.6',
            color: '#009CD2',
          }}
        >
          {title}
        </div>
      </div>

      {/* コンテンツエリア */}
      <div className="relative z-10">{children}</div>
    </div>
  )
}
